import ConnectivityApp from '@components/connectivity/ConnectivityApp';
import { configureConnectivityStore } from '@state';
import React from 'react';
import { Provider } from 'react-redux';
const store = configureConnectivityStore();
const Connectivity = (props) => {
    return (React.createElement(Provider, { store: store },
        React.createElement(ConnectivityApp, Object.assign({}, props))));
};
export default Connectivity;
